<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('分类名称')" prop="categoryName">
                <a-input v-model="queryParam.categoryName" @pressEnter="handleQuery" :maxLength="16" :placeholder="$t('请输入')+$t('分类名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="品类编码" prop="categoryCode">
                <a-input v-model="queryParam.categoryCode" @pressEnter="handleQuery" :maxLength="4" placeholder="请输入品类编码" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item label="商品分类" prop="goodsType">
                <a-select placeholder="请选择商品分类" style="width: 100%" v-model="queryParam.goodsType" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.GoodsTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24" v-if="!bizScopeLocked">
              <a-form-item label="商城归属" prop="bizScope">
                <a-select placeholder="请选择商城归属" style="width: 100%" v-model="queryParam.bizScope" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.BizScopeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('是否显示')" prop="isVisible">
                <a-select :placeholder="$t('请选择')+$t('是否显示')" style="width: 100%" v-model="queryParam.isVisible" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type+''"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('上级分类')" prop="pid">
                <a-select style="width: 100%"  show-search
                          :filter-option="filterOption"  @change="handlePidChange"
                          v-model="queryParam.pid" :placeholder="$t('请输入')+$t('上级分类')">
                  <a-select-option v-for="(item, index) in parentList" :value="item.id" :key="index">
                    {{ item.categoryName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAddSecondLevel" v-if="bizScopeRoot" v-hasPermi="['goods:category:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['goods:category:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 分类属性模板 -->
      <param-template-drawer ref="paramTemplateDrawer" />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        childrenColumnName="children"
        :expandIcon="tableExpandIcon"
        :expanded-row-keys.sync="expandedKeys"
        @change="handleSortChange"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="categoryPic" slot-scope="text, record">
          <div>
            <img v-if="record.categoryPic" :src="record.categoryPic"  style="width:60px;height:60px;" @click="handleRecordPreview(record.categoryPic)" alt="none"/>
          </div>
        </template>
        <template slot="sort" slot-scope="text, record">
          <div class="drag-handle" v-if="record.level===1 || showChildren">
            <a-icon style="font-size: 16px;color: #00afff;margin-right: 8px" type="drag" />
            <span class="sort-number">{{record.sort}}</span>
          </div>
        </template>
        <span slot="isFilter" slot-scope="text, record">
            <!-- 重写自定义了个字典组件-->
           <custom-dict-tag :options="customDict.TFEnum" :value="record.isFilter"/>
        </span>
        <span slot="goodsType" slot-scope="text, record">
            <!-- 重写自定义了个字典组件-->
           <custom-dict-tag :options="customDict.GoodsTypeEnum" :value="record.goodsType"/>
        </span>
        <span slot="bizScope" slot-scope="text, record">
           <custom-dict-tag :options="customDict.BizScopeEnum" :value="record.bizScope"/>
        </span>
        <span slot="isHomeVisible" slot-scope="text, record">
          <a-switch @change="(checked) => onHomeVisibleChange(checked,record)" :checked-children="$t('是')" :un-checked-children="$t('否')" :checked="record.isHomeVisible"/>
        </span>
        <span slot="isVisible" slot-scope="text, record">
          <a-switch @change="(checked) => onVisibleChange(checked,record)" :checked-children="$t('是')" :un-checked-children="$t('否')" :checked="record.isVisible"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['goods:category:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['goods:category:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['goods:category:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
          <a-divider type="vertical"  v-if="record.level<4" v-hasPermi="['goods:category:add']" />
          <a @click="$refs.createForm.handleAdd(record)" v-if="record.level<4" v-hasPermi="['goods:category:add']">
             <a-icon type="plus" />添加下级
          </a>
          <a-divider type="vertical" v-hasPermi="['goods:category:edit']" />
          <a @click="$refs.paramTemplateDrawer.openDrawer(record)" v-hasPermi="['goods:category:edit']">
             <a-icon type="profile" />属性模板
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        v-if="!bizScopeLocked"
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>

</template>

<script>
import {platformCategoryPage, delCategory, updateVisible, sortCategory, platformCategoryList} from '@/api/goods/category';
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import CreateForm from '../modules/CreateForm'
import ParamTemplateDrawer from '../modules/ParamTemplateDrawer'
import { tableMixin } from '@/store/table-mixin'
import bus from "@/utils/bus";
import Sortable from 'sortablejs'
import { createTableExpandIcon } from '@/utils/tableExpandIcon'

export default {
  name: 'Category',
  components: {
    CustomDictTag,
    CreateForm,
    ParamTemplateDrawer
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      parentList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      filteredInfo: {},
      sortedInfo : {},
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      expandedKeys: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      showChildren: false,
      // 乐器分类/配件分类/二手分类 三个子菜单共用本页面，此时商城归属由菜单固定，隐藏归属筛选
      bizScopeLocked: false,
      // 该商城归属的一级根节点（列表已隐藏它，单独记录用于新增二级分类）
      bizScopeRoot: null,
      // 查询参数
      queryParam: {
        categoryName: null,
        categoryCode: null,
        categoryPic: null,
        goodsType: undefined,
        bizScope: undefined,
        pid: null,
        level: 1,
        merchantId: 0,
        isVisible: undefined,
        isHomeVisible: undefined,
        sort: null,
        sortField: "sort",
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('分类名称'),
          dataIndex: 'categoryName',
          width: '15%',
          ellipsis: true,
          align: 'left'
        },
        {
          title: '品类编码',
          dataIndex: 'categoryCode',
          width: '8%',
          align: 'center'
        },
        {
          title: this.$t('分类图片'),
          dataIndex: 'categoryPic',
          scopedSlots: { customRender: 'categoryPic' },
          align: 'center'
        },
        {
          title: '商城归属',
          dataIndex: 'bizScope',
          scopedSlots: { customRender: 'bizScope' },
          align: 'center'
        },
/*        {
          title: '商品类型',
          dataIndex: 'goodsType',
          scopedSlots: {customRender: 'goodsType'},
          align: 'center'
        },*/
        {
          title: this.$t('上级分类'),
          dataIndex: 'parentCategoryName',
          align: 'center'
        },
        {
          title: this.$t('分类等级'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'level',
          align: 'center'
        },
        {
          title: this.$t('是否显示'),
          dataIndex: 'isVisible',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'isVisible' },
          align: 'center'
        },
        {
          title: this.$t('是否首页展示'),
          dataIndex: 'isHomeVisible',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'isHomeVisible' },
          align: 'center'
        },
        {
          title: this.$t('排序'),
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' },
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title:  this.$t('创建时间'),
          dataIndex: 'createTime',
          sorter: 1,
          ellipsis: true,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '9%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.applyRouteBizScope()
    this.getList()
    this.getParentList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted() {
    this.$nextTick(() => {
      this.initDrop()
    })
  },
  methods: {
    /** 按菜单路由确定商城归属：乐器分类=1、二手分类=2、配件分类=3 */
    applyRouteBizScope () {
      const scopeByPath = {
        instrument: 1,
        secondhand: 2,
        accessory: 3
      }
      const segments = (this.$route.path || '').split('/').filter(Boolean)
      const bizScope = scopeByPath[segments[segments.length - 1]]
      if (bizScope === undefined) {
        return
      }
      this.bizScopeLocked = true
      this.queryParam.bizScope = bizScope
      // 跳过该归属的一级根节点，直接以二级分类作为列表顶层
      this.queryParam.level = 2
      // 分页条已隐藏，放大每页条数，避免顶层分类过多时被截断
      this.queryParam.pageSize = 100
    },
    /** 收集所有存在下级的节点 id，用于默认展开完整分类树 */
    collectExpandableIds (rows) {
      const ids = []
      const walk = list => {
        (list || []).forEach(row => {
          if (row.children && row.children.length) {
            ids.push(row.id)
            walk(row.children)
          }
        })
      }
      walk(rows)
      return ids
    },
    tableExpandIcon (props) {
      return createTableExpandIcon(this.$createElement)(props)
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商品分类列表 */
    getList () {
      this.loading = true
      if (this.queryParam.pid) {
        this.showChildren = true
      } else {
        this.showChildren = false
      }
     platformCategoryPage(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.expandedKeys = this.collectExpandableIds(this.list)
        this.loading = false
      });
    },
    getParentList () {
      this.loading = true
      const param = this.queryParam.bizScope === undefined ? {} : { bizScope: this.queryParam.bizScope }
      platformCategoryList(param).then(response => {
        this.parentList= response.data
        if (this.bizScopeLocked) {
          // 一级根节点已不在列表里展示，单独记下来作为新增二级分类的上级
          this.bizScopeRoot = (response.data || []).find(item => item.level === 1) || null
        }
      })
    },
    /** 新增二级分类：上级固定为该商城归属的一级根节点 */
    handleAddSecondLevel () {
      this.$refs.createForm.handleAdd(this.bizScopeRoot)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handlePidChange(value) {
      this.queryParam.pid = value
      this.queryParam.level = null
    },

    initDrop() {
      const tbody = document.querySelector('.draggable-table tbody')
      if (!tbody) return

      const that = this
      // 树展开后 tbody 内混有子级行，行索引无法直接对应 this.list，故按行的 data-row-key 定位
      let rowKeys = []
      Sortable.create(tbody, {
        handle: '.drag-handle',
        animation: 150,
        onStart: function () {
          rowKeys = Array.prototype.map.call(tbody.children, function (tr) {
            return tr.getAttribute('data-row-key')
          })
        },
        onEnd: function ({ oldIndex, newIndex }) {
          if (oldIndex === newIndex) {
            return
          }
          const movedItem = that.findCategoryByKey(rowKeys[oldIndex])
          const targetItem = that.findCategoryByKey(rowKeys[newIndex])
          if (!movedItem || !targetItem) {
            that.getList()
            return
          }
          console.log(movedItem.categoryName, targetItem.categoryName)
          // Prepare request data
          const data = {
            id1: movedItem.id,
            id2: targetItem.id,
          }
          // Call API to update sort order
          sortCategory(data).then(() => {
            that.getList()
            that.$message.success('排序更新成功')
          })
        }
      })
    },
    /** 在分类树中按行 key 查找节点 */
    findCategoryByKey(key) {
      if (!key) {
        return null
      }
      const walk = (rows) => {
        for (const row of rows || []) {
          if (String(row.id) === String(key)) {
            return row
          }
          const hit = walk(row.children)
          if (hit) {
            return hit
          }
        }
        return null
      }
      return walk(this.list)
    },
    onExpandCurrent(expandedKeys, row) {
      if (expandedKeys) {
        this.expandedKeys = [row.id]
      } else {
        this.expandedKeys = []
      }
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      // 按分类名称/品类编码搜索时取消层级与上级限制，否则二级及以下分类搜不到
      if (this.queryParam.categoryName || this.queryParam.categoryCode) {
        this.queryParam.pid = undefined
        this.queryParam.level = undefined
      } else if (this.bizScopeLocked) {
        // 清空搜索条件后回到子菜单默认视图：仍以二级分类作为顶层
        this.queryParam.pid = undefined
        this.queryParam.level = 2
      }
      this.getList()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        categoryName: undefined,
        categoryPic: undefined,
        goodsType: undefined,
        bizScope: this.queryParam.bizScope,
        pid: undefined,
        merchantId: 0,
        level: this.bizScopeLocked ? 2 : 1,
        isVisible: undefined,
        isHomeVisible: undefined,
        sortField: "sort",
        pageNum: 1,
        pageSize: this.bizScopeLocked ? 100 : 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    onHomeVisibleChange(checked, record) {
      let data = {id:record.id, isHomeVisible: checked}
      updateVisible(data).then(response => {
          if (response.success) {
            this.$message.success(
              this.$t('修改成功'),
              3
            );
            this.$emit('ok')
            record.isHomeVisible=checked
          }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    onVisibleChange(checked, record) {
      let data = {id:record.id, isVisible: checked}
      updateVisible(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('修改成功'),
            3
          );
          this.$emit('ok')
          record.isVisible=checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },

    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      const names = row.name
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      const data = {"idList": this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delCategory(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('删除成功'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/goods/category/export',
            that.queryParam
          , `商品分类_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
<style lang="less">
.imgbox {
  overflow: hidden;
  background-color: #f7f7f7;
  position: relative;
  cursor: pointer;

  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.videomask {
  position: absolute;
  z-index: 10;
  width: 100px;
  height: 100px;
  margin: 0 auto;
  line-height: 100px;
  background: rgba(0, 0, 0, .3);
  text-align: center;

  .icon {
    display: inline-block;
    font-size: 26px !important;
    color: #fff !important;
  }
}
</style>
